import styled from 'styled-components';

type SolicitationContainerProps = {
  viewInfo?: boolean;
};
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  .subHeader {
    display: flex;
    gap: 1rem;
    align-items: center;
    h1 {
      color: #b10000;
      font-size: 1.1rem;
      margin: 0;
      font-weight: medium;
    }
  }
  svg {
    height: 2.5rem;
    fill: #b10000;
  }
  button {
    color: ${({ theme }) => theme.colors.background_white};
    background: ${({ theme }) => theme.colors.tertiary_500};
    border: none;
    border-radius: 2rem;
    cursor: pointer;
  }
`;

export const ContentModal = styled.div`
  .buttonModal {
    width: 100%;
    display: flex;
    gap: 5rem;
    margin-top: 1rem;
    justify-content: center;
  }
  h3 {
    font-weight: 450;
    color: ${({ theme }) => theme.colors.secondary};
    margin: 1rem 0 0.5rem 3rem;
  }
  transition: height 100s;
`;
export const SolicitationContainer = styled.div<SolicitationContainerProps>`
  padding: 1rem;
  margin: 0 2.5rem;
  border-radius: 0.9rem;
  background-color: ${({ theme }) => theme.colors.background_white};
  .content-view-more-info {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    z-index: 1;
    button {
      color: ${({ theme }) => theme.colors.tertiary_500};
      background-color: transparent;
      width: 8rem;
      height: 1rem;
      padding: 0;
      margin-bottom: 0;
      padding: 0;
      border: 0;
      transition: opacity 0.2s;
      :hover {
        opacity: 0.6;
        cursor: pointer;
        text-decoration: underline;
        border: 0;
      }
      p {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      svg {
        width: 0.8rem;
        margin: 0.2rem;
      }
    }
  }
  h2 {
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.secondary};
    font-weight: 500;
  }
  .content-information-solicitation {
    display: grid;
    grid-template-columns: 50% 50%;
    .content-space {
      margin-top: 1rem;
    }
    p {
      color: ${({ theme }) => theme.colors.text};
    }
  }
  .containerMapAttachment {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    width: 94%;
    margin-left: 0.5rem;
    height: 3.3rem;
    overflow-y: auto;
    ::-webkit-scrollbar {
      width: 8px;
      background-color: ${({ theme }) => theme.colors.background};
      border-radius: 10px;
    }
    ::-webkit-scrollbar:horizontal {
      height: 5px;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-horizontal {
      border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-thumb:horizontal {
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      border-radius: 10px;
    }
  }
  .containerNote {
    width: 100%;
    gap: 1rem;
    margin: 1rem 0;
    p {
      width: 94%;
      margin-left: 0.5rem;
      height: 5rem;
      font-size: 1.2rem;
      overflow-y: auto;
      ::-webkit-scrollbar {
        width: 8px;
        background-color: ${({ theme }) => theme.colors.background};
        border-radius: 10px;
      }
      ::-webkit-scrollbar:horizontal {
        height: 5px;
      }
      ::-webkit-scrollbar-track,
      ::-webkit-scrollbar-track-horizontal {
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb,
      ::-webkit-scrollbar-thumb:horizontal {
        background-color: ${({ theme }) => theme.colors.tertiary_500};
        border-radius: 10px;
      }
    }
  }
`;
